import { Tag } from '..';
import type { TTagProps } from '../types/TProps';

export const TagSearchActive = ({ className = '', ...props }: TTagProps) => (
  <Tag {...props} className={['tag--search-active', className].filter(Boolean).join(' ')} />
);
